export const noteCardSx = {
  root: {
    backgroundColor: "#E9EEF0",
    display: "flex",
    padding: 0,
    flexDirection: "column",
    cursor: "pointer",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2xp)",
      boxShadow: 3,
    },
  },
  header: {
    heigth: 32,
    display: "flex",
    padding: "0 16px",
    marginTop: 2,
    flexDirection: "column",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "8px 16px",
  },
  footer: {
    height: 24,
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    marginBottom: 2,
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  type: {
    fontSize: "10px",
    fontWeight: "bold",
  },
  date: {
    fontSize: "10px",
    color: "#616161",
  },
  description: {
    fontSize: "11px",
  },
  button: {
    fontSize: "9px",
    color: "#616161",
  },
};
